import httpClient from './httpClient';

export default {
  getReviews: ({ apiKey, externalId, reviewQueryStrings }) =>
    httpClient.post(`/api/reviews/${apiKey}/${externalId}${reviewQueryStrings}`),
  getGMBReviews: ({ department, profileId, page, sort }) =>
    httpClient.get(`${process.env.VUE_APP_REVIEWS_URL}/reviews/${department}/${profileId}/${page}/${sort}`),
  getReviewInfo: (apiKey, externalId) => httpClient.post(`/api/reviews/info/${apiKey}/${externalId}`),
  getGMBReviewInfo: reviewId => httpClient.get(`${process.env.VUE_APP_REVIEWS_URL}/ratings/${reviewId}`),
};
